import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { SupportService } from './support.service';

const pageOption =
    /^(selected[A-Z_]|dateRange$|dateInput$|startDate$|endDate$|fromDate$|toDate$|year$|month$|period$|currency$|pickupDays$)/;

@Directive({ selector: 'router-outlet[pulseSupportContext]' })
export class SupportPageContextDirective implements OnInit, OnDestroy {
    private outlet = inject(RouterOutlet);
    private support = inject(SupportService);
    private subscription: Subscription;
    private unregister: () => void;

    ngOnInit(): void {
        this.subscription = this.outlet.activateEvents.subscribe(component =>
            this.register(component)
        );
        if (this.outlet.isActivated) this.register(this.outlet.component);
    }

    private register(component: object): void {
        this.unregister?.();
        this.unregister = this.support.registerPageContext(
            () => {
                const options: Record<string, unknown> = {};
                // Only explicit selection/date properties, never response data or injected services.
                for (const key of Object.keys(component)) {
                    if (pageOption.test(key)) options[key] = component[key];
                }
                return options;
            },
            () => this.outlet.isActivated && this.outlet.component === component
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.unregister?.();
    }
}
